import { type FunctionComponent } from 'react';
import { SvgIcon, type SvgIconProps } from './SvgIcon';

export const SuccessCircle: FunctionComponent<SvgIconProps> = (props) => {
  return (
    <SvgIcon height="48px" viewBox="0 0 48 48" width="48px" {...props}>
      <svg>
        <path
          d="M24 0C17.6348 0 11.5303 2.52856 7.02944 7.02944C2.52856 11.5303 0 17.6348 0 24C0 30.3652 2.52856 36.4697 7.02944 40.9706C11.5303 45.4714 17.6348 48 24 48C30.3652 48 36.4697 45.4714 40.9706 40.9706C45.4714 36.4697 48 30.3652 48 24C48 17.6348 45.4714 11.5303 40.9706 7.02944C36.4697 2.52856 30.3652 0 24 0ZM20 34L10 24L12.8 21.2L20 28.4L35.2 13.2L38 16L20 34Z"
          fill="#78A12F"
        />
      </svg>
    </SvgIcon>
  );
};
